import "./tarifsDefault.css";
import TarifsTextTitle from "./components/tarifsTextTitle";
import TarifsTextContent from "./components/tarifsTextContent";

import TarifsTextDeroulement from "./components/tarifsTextDeroulement";
import TarifsTextNotes from "./components/tarifsTextNotes";

function TarifsDiag() {
  const descriptionList = [
    "Un ordinateur en panne ne signifie pas forcément une réparation coûteuse. Le diagnostic permet d'identifier précisément le problème avant toute intervention.",
    "Une fois le problème identifié, nous vous proposons une solution adaptée et un devis clair pour la réparation.",
  ];
  const deroulementList = [
    "1 - Prise de rendez vous : Nous convenons d'un rendez vous à notre atelier avec votre ordinateur ou directement à votre domicile.",
    "2 - Analyse des symptômes : Discussion avec vous sur le problème rencontré et vérification des signes visibles (message d'erreur, écran noir, surchauffe, bruits inhabituels…).",
    "3 - Tests matériels et logiciels : Contrôle des composants internes (RAM, disque dur, alimentation…) avec des outils de diagnostic avancés et vérification du bon fonctionnement du système d'exploitation et des logiciels.",
    "4 - Identification et rapport de panne : Explication claire du problème et de ses causes potentielles.",
    "5 - Proposition de solution et devis : Nous vous informons des réparations nécessaires, du coût et du temps d'intervention. Vous décidez ensuite si vous souhaitez procéder à la réparation.",
  ];
  return (
    <div className="tarifs-text-main-contenair">
      <TarifsTextTitle
        title="DIAGNOSTIC"
        price="30€ TTC"
        atelier={true}
        domicile={true}
        time="15min - 1h"
      />
      <div className="tarifs-text-main">
        <div className="tarifs-text-colA">
          <TarifsTextContent content={descriptionList} h="100%" />
        </div>
        <div className="tarifs-text-colB">
          <TarifsTextDeroulement operations={deroulementList} />
        </div>
      </div>
      <TarifsTextNotes notes="Si durant le diagnostic la panne vient à se résoudre d'elle même cela ne vous coutera rien de plus !" />
    </div>
  );
}

export default TarifsDiag;
